module.exports = __webpack_public_path__ + "static/media/navySmiley.dcf8779d.png";